<template>
	<div class="read-receipts" :class="{ 'has-receipts': hasReceipts }">
		<ProfileList
			:userIds="sortedUserIds"
			:max="MAX_RECEIPTS"
			enableOnline
			onlineSize="7px"
			size="16px"
			clickable
			@click="showReadReceiptsModal = true"
		/>
		<ThreadLine v-if="showThreadLine" />

		<ReadReceiptsModal
			v-if="showReadReceiptsModal"
			:receiptsUrl="`messages/${message.id}/receipts`"
			:countsUrl="`messages/${message.id}/receipts/counts`"
			:bubbleId="message.bubble_id"
			@cancel="showReadReceiptsModal = false"
		/>
	</div>
</template>

<script>
import {
	getMembershipForUserAndBubble,
	sortMembershipsByMarkUpdated,
} from '@/store'
import ProfileList from './ProfileList'
import ThreadLine from './ThreadLine'
import ReadReceiptsModal from './ReadReceiptsModal'

const MAX_RECEIPTS = 20

export default {
	name: 'ReadReceipts',
	components: { ProfileList, ThreadLine, ReadReceiptsModal },
	props: ['userIds', 'showThreadLine', 'message'],
	inheritAttrs: false,
	data() {
		return {
			MAX_RECEIPTS,
			showReadReceiptsModal: false,
		}
	},
	computed: {
		hasReceipts() {
			return this.userIds.length > 0
		},
		sortedUserIds() {
			// Scope membership lookup to this message's chat — falling back
			// to `store.currentChatId` (the old behavior) would miss
			// receipts when the message belongs to a chat the user isn't
			// currently viewing (e.g. the activity preview panel).
			const bubbleId = this.message?.bubble_id
			return this.userIds
				.map((userId) => getMembershipForUserAndBubble(userId, bubbleId))
				.filter((m) => m)
				.sort(sortMembershipsByMarkUpdated)
				.map((m) => m.user_id)
				.reverse()
		},
	},
}
</script>

<style lang="scss" scoped>
$height: 24px;

.read-receipts {
	position: relative;
	width: 100%;
	display: flex;
	justify-content: flex-end;
	height: 0;
	margin: 0;
	overflow: hidden;
	transition: all 0.15s ease-in-out 0.1s;
	transition-property: margin, height;
	&.has-receipts {
		height: $height;
		margin: -6px 0;
	}
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.read-receipts {
		.online-indicator {
			border-color: var(--neutral-0);
		}
	}
}
</style>
